
import './Showcase.css';
import { Image } from 'react-bootstrap';
import Tumbler from '../../assets/Images/TumblerHero.webp';

import EasyToUse from '../../assets/Icons/East-to-use-icon.svg';
import Effective from '../../assets/Icons/Effective-Icon.svg';
import Efficient from '../../assets/Icons/Efficient-icon.svg';
import SafeIcon from '../../assets/Icons/Safe-icon.svg';


const Showcase = () => {
  return (
    <div className='container'>
      <div className="showCaseContainer">
        <Image className='hero' src={Tumbler} />
      </div>
      <div className='showCaseContainerInnerRight'>
        <div className='showCaseListItem'>
          <Image className='showCaseIcon' src={Effective} />
          <div className='innerItem'>
            <h5 style={{ fontWeight: 'bold' }}>EFFECTIVE</h5>
            <p className='innerP'>Battle-tested thousands of treatments to completely remove organic odors.</p>
          </div>
        </div>
        <div className='showCaseListItem'>
          <Image className='showCaseIcon' src={SafeIcon} />
          <div className='innerItem'>
            <h5 style={{ fontWeight: 'bold' }}>SAFE</h5>
            <p className='innerP'>Designed to protect you from exposure to harmful chemicals.</p>
          </div>
        </div>
        <div className='showCaseListItem'>
          <Image className='showCaseIcon' src={Efficient} />
          <div className='innerItem'>
            <h5 style={{ fontWeight: 'bold' }}>EFFICIENT</h5>
            <p className='innerP'>Delivers results in 20 minutes with proven, proprietary technology.</p>
          </div>
        </div>
        <div className='showCaseListItem'>
          <Image className='showCaseIcon' src={EasyToUse} />
          <div className='innerItem'>
            <h5 style={{ fontWeight: 'bold' }}>EASY TO USE</h5>
            <p className='innerP'>Professional technicians not required.</p>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Showcase;